import { render, staticRenderFns } from "./Prouni.vue?vue&type=template&id=7fa5f1e9&scoped=true&lang=pug&"
import script from "./Prouni.vue?vue&type=script&lang=js&"
export * from "./Prouni.vue?vue&type=script&lang=js&"
import style0 from "./Prouni.styl?vue&type=style&index=0&id=7fa5f1e9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa5f1e9",
  null
  
)

export default component.exports